export enum GlobalAction {
  ShowLoadingScreen = 'global/showLoadingScreen',
  HideLoadingScreen = 'global/hideLoadingScreen',
  OpenToaster = 'global/openToaster',
  CloseToaster = 'global/closeToaster',
}

export interface LoadingState {
  isLoading: boolean;
  loadingTitle: string;
}

export interface ToasterState {
  toasterOwner?: symbol;
  isToasterOpen: boolean;
  toasterTitle: string;
  toasterVariant?: string;
  toasterChildren: string;
}

export interface GlobalState extends LoadingState, ToasterState {}

export interface GlobalActions {
  showLoadingScreen: (title: string) => void;
  hideLoadingScreen: () => void;
  openToaster: (payload: { title: string; children: string; variant?: string }, owner?: symbol) => void;
  closeToaster: (owner?: symbol) => void;
}

export type GlobalSlice = GlobalState & GlobalActions;
